import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../Buttons/Button';
import Modal from '../Modal';
import style from '../../../../scss/components/list.module.scss';

const DeleteConfirmModal = ({
    isOpen,
    onRequestClose,
    onConfirm,
    error,
    isDeleting,
    children,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            contentLabel={t('application.confirm_delete_title')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            {children}
            {error ? (
                <div className={style.errorMessage}>{error}</div>
            ) : (
                <Button name="delete" click={onConfirm} disabled={isDeleting} />
            )}
        </Modal>
    );
};

export default DeleteConfirmModal;

DeleteConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    error: PropTypes.string,
    isDeleting: PropTypes.bool,
    children: PropTypes.node,
};

DeleteConfirmModal.defaultProps = {
    error: null,
    isDeleting: false,
    children: null,
};
